/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import { Container, Tab, Tabs } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { AppRulesContext } from "../../App";
import UsersApi from "../../api/UsersApi";
import PageHeader from "../../components/PageHeader";
import CardLoader from "../../components/content-loader/CardLoader";
import { NothingAvailable } from "../../components/placeholders";
import AdminUserCP from "../../components/tabs/users/AdminUserCP";
import AdminUserFilings from "../../components/tabs/users/AdminUserFilings";
import AdminUserProfile from "../../components/tabs/users/AdminUserProfile";
import { EToastvariant, IUserResponse } from "../../config/interfaces";
import { useAppDispatch } from "../../redux/Store";
import { showToastMsg } from "../../redux/slice/ToastMsgSlice";
import { UtilService } from "../../services";

const UserDetails = () => {
  const dispatch = useAppDispatch();
  const [isFetching, setIsFetching] = useState(true);
  const [userData, setUserData] = useState<IUserResponse>();
  const { uUId } = useParams();
  const { rulesSvc } = useContext(AppRulesContext);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const pathName = pathname.split("/");

  useEffect(() => {
    getUserDetails();
  }, []);

  const getUserDetails = async () => {
    try {
      if (!uUId) {
        return;
      }

      setIsFetching(true);
      const adminUsersApi = UsersApi.getInstance();
      const UserResp = await adminUsersApi.getUserById(uUId);
      const _data = UserResp;
      setUserData(_data);
    } catch (error) {
      dispatch(
        showToastMsg({
          isVisible: true,
          title: "Error",
          message: UtilService.getErrorMessage(error),
          variant: EToastvariant.Danger
        })
      );
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <>
      <Container className="w-800">
        {isFetching ? (
          <>
            <PageHeader backIconButton={true} title="User" />
            <CardLoader cardType="details" />
          </>
        ) : userData?.uuid ? (
          <>
            <PageHeader
              backIconButton={true}
              title={userData?.fullName || ""}
              titleClass="text-capitalize"
            />
            <div className="tabs-wrapper">
              <Tabs defaultActiveKey="profile" id="eds-admin-settings">
                {/* Profile tab  */}
                <Tab eventKey="profile" title="Profile">
                  <AdminUserProfile pageName="users" />
                </Tab>

                {/* Filings by User tab  */}
                {rulesSvc.canAccess(rulesSvc.eFilingList) && (
                  <Tab eventKey="filings" title="Filings by User">
                    <AdminUserFilings />
                  </Tab>
                )}

                {/* Change Password tab  */}
                {rulesSvc.canAccess(rulesSvc.userChangePassword) && (
                  <Tab eventKey="change-password" title="Change Password">
                    <AdminUserCP pageName="users" />
                  </Tab>
                )}
              </Tabs>
            </div>
          </>
        ) : (
          <>
            <div className="text-center my-5">
              <NothingAvailable
                title="Something Went Wrong"
                message="Failed to fetch data from the server. Please try again later."
                btnTitle="Go to Users"
                onBtnPress={() => navigate(`/${pathName[1]}`, { replace: true })}
                btnRules={rulesSvc.usersList}
              />
            </div>
          </>
        )}
      </Container>
    </>
  );
};

export default UserDetails;
